module.exports = __webpack_public_path__ + "img/snow-blowing.ba817502.svg";